import React from "react";
import { useSelector } from "react-redux";

const AuthFive = () => {
  const locale = useSelector((state) => state.theme.locale);

  return (
    <div
      className="flex-1 flex flex-col items-center justify-center bg-no-repeat bg-cover text-center p-5"
      style={{ backgroundImage: `url('/img/auth/5.jpg')` }}
    >
      {locale === "en" ? (
        <p className="mb-10 text-[32px] text-white leading-snug max-w-[632px]">
          Discover the most suitable and eco-friendly solutions for your waste
          with Mol-e. Easily manage your waste through our smart platform,
          reduce your carbon footprint, and lower your costs.
          <br /> <br />
          Take control of your waste management with just a few clicks.
        </p>
      ) : (
        <p className="mb-10 text-[32px] text-white leading-snug max-w-[632px]">
          Mol-e ile atıklarınız için en uygun ve çevre dostu çözümleri keşfedin.
          Akıllı platformumuz sayesinde atıklarınızı kolayca yönetin, karbon
          ayak izinizi azaltın ve maliyetlerinizi düşürün.
          <br /> <br />
          Sadece birkaç tıklama ile atık yönetimini kontrol altına alın.
        </p>
      )}

      <div className="flex items-center justify-between max-w-[632px] w-full gap-10 mt-10">
        <img alt="Waste" src="/img/auth/waste.png" />
        <img alt="Cert" src="/img/auth/cert.png" />
      </div>
    </div>
  );
};

export default AuthFive;
